<template>
  <div>
    <div
      style="
        border-bottom: 1px solid rgba(155, 155, 155, 0.25);
        margin-bottom: 20px;
      "
    >
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="填报单位" style="margin-right: 30px">
          <el-input v-model="formInline.name" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="地区">
          <el-select clearable v-model="formInline.region" placeholder="请选择">
            <el-option
              :key="item.code"
              :label="item.name"
              :value="item.code"
              v-for="item in seatList"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="报表">
          <el-select v-model="formInline.report_cycle" placeholder="请选择">
            <el-option label="重点监测企业产值表" value="001"></el-option>
            <el-option label="重点监测企业财务表" value="002"></el-option>
            <el-option label="工业园区基本情况表" value="003"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="填报期">
          <el-date-picker
            clearable
            v-model="formInline.date_range"
            type="month"
            format="yyyy-MM"
            value-format="yyyy-MM"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="是否规上企业">
          <el-select
            clearable
            v-model="formInline.above_scale"
            placeholder="请选择"
          >
            <el-option label="是" value="是"></el-option>
            <el-option label="否" value="否"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="onSubmit"
            class="bg5584FF formBotton"
            >查询</el-button
          >
          <el-button type="info" @click="reset" class="formBotton"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div style="margin-bottom: 24px">
      <el-button type="primary" @click="toPass(selectRow, 1)" class="bg5584FF"
        >批量催报</el-button
      >
    </div>
    <el-link style="margin-bottom: 20px" type="primary" @click="exportData">{{
      exportLabel
    }}</el-link>
    <el-table
      border
      :data="tableData"
      stripe
      style="width: 100%"
      :header-cell-style="{ backgroundColor: '#DCDFE6', color: '#000' }"
      v-loading="loading"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column prop="company_name" label="填报单位" align="center">
      </el-table-column>
      <el-table-column prop="name" label="填报名" align="center">
      </el-table-column>
      <el-table-column prop="date_range" label="填报期" align="center">
        <template slot-scope="scope">
          <span>{{ getDateRange(scope.row) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="date_range" label="填报开始时间" align="center">
      </el-table-column>
      <el-table-column
        prop="date_range_end"
        label="填报结束时间"
        align="center"
      >
      </el-table-column>
      <el-table-column prop="count" label="催报次数" align="center">
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        class="dialog770 titleChange"
      >
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            class="bg5584FF"
            @click="toPass([scope.row.id], 2)"
            >催报</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pageBox">
      <!-- <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        :page-sizes="[20, 30, 50, 100]"
        layout="sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination> -->
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="20"
        layout="total,  prev, pager, next"
        :total="total"
      >
      </el-pagination>
    </div>
    <el-dialog
      append-to-body
      title="发送催报"
      :visible.sync="passDialogVisible"
      :close-on-click-modal="false"
      class="titleChange"
      width="770px"
    >
      <el-form
        :model="passForm"
        :rules="rules"
        ref="passForm"
        label-width="135px"
        class="demo-RuleForm"
        size="small"
        v-loading="passLoading"
      >
        <el-form-item label="报表催报意见：" prop="reason">
          <el-input v-model="passForm.reason"></el-input>
        </el-form-item>
      </el-form>
      <div class="btnBox">
        <el-button type="primary" @click="surePass()">确定</el-button>
        <el-button @click="passDialogVisible = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { export2Excel } from "@/utils/utils";
import { mapGetters } from "vuex";
export default {
  name: "index",
  props: {
    report_cycle: {
      type: String,
      default: "",
    },
    method: {
      type: String,
      default: "",
    },
    region: {
      type: String,
      default: "",
    },
    date_range: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      tableData: [],
      currentPage: 1,
      loading: false,
      formInline: {
        //查询对象
        name: "",
        region: "",
        report_cycle: "",
        date_range: "",
        above_scale: "",
      },
      notPassForm: {
        reason: "",
      },
      regionTree: [],
      passForm: {
        reason: "",
      },
      selectRow: [],
      sureList: [],
      showObj: {},
      pageSize: 20,
      exportLabel: "<<点击此处可导出报表",
      notPassDialogVisible: false,
      passDialogVisible: false,
      notPassLoading: false,
      passLoading: false,
      total: 0, //表格总数
      rules: {
        //表单验证规则
        reason: [{ required: true, message: "请输入意见", trigger: "blur" }],
      },
      detailDialogVisible: false,
      showDialogVisible: false,
    };
  },
  computed: {
    ...mapGetters({
      seatList: "getAreaLists",
    }),
  },
  methods: {
    getDateRange(row) {
      const month = Number(row.date_range.split("-")[1]);
      const year = Number(row.date_range.split("-")[0]);
      if (row.report_cycle == 0) {
        //月报
        return row.date_range;
      } else if (row.report_cycle == 1) {
        //季报
        if (month <= 3) {
          return `${year}年第一季度`;
        } else if (month >= 4 && month <= 6) {
          return `${year}年第二季度`;
        } else if (month >= 7 && month <= 9) {
          return `${year}年第三季度`;
        } else {
          return `${year}年第四季度`;
        }
      } else if (row.report_cycle == 2) {
        //半年报
        if (month <= 6) {
          return `${year}年上半年`;
        } else {
          return `${year}年下半年`;
        }
      } else {
        //年报
        return `${year}年`;
      }
    },
    getdata(page) {
      this.loading = true;
      this.tableData = [];
      const param = {
        page: page || 1,
        pageSize: this.pageSize,
        status: "wsb",
      };
      if (this.formInline.name !== "") {
        param["name"] = this.formInline.name;
      }
      if (this.formInline.region !== "") {
        param["region"] = this.formInline.region;
      }
      if (this.formInline.report_cycle !== "") {
        param["report_cycle"] = this.formInline.report_cycle;
      }
      if (this.formInline.date_range && this.formInline.date_range !== "") {
        param["date_range"] = this.$moment(this.formInline.date_range).format(
          "YYYY-MM"
        );
      }
      if (this.formInline.above_scale !== "") {
        param["above_scale"] = this.formInline.above_scale;
      }
      let methods = "/business/insertMonitor/queryHandleList";
      if (this.method === "noRole") {
        methods = "/business/insertMonitor/showCompanyByName";
      }
      this.$axios.post(methods, param).then((res) => {
        this.loading = false;
        res.data.forEach((temp) => {
          if (temp.park_name) {
            temp.company_name = temp.park_name;
            temp.company_phone = temp.park_phone;
          }
          temp.crt_time = this.$moment(temp.crt_time).format(
            "YYYY-MM-DD HH:mm:ss"
          );
          temp.date_range_end = this.$moment(temp.date_range_end)
            .endOf("month")
            .format("YYYY-MM-DD");
        });

        this.tableData = res.data;
        console.log(this.tableData);
        this.total = res.total;
      });
    },
    toDetail(row) {
      this.showDialogVisible = true;
    },
    handleDetail(row) {
      this.showObj = row;
      this.detailDialogVisible = true;
    },
    surePass() {
      this.$refs.passForm.validate((valid) => {
        if (valid) {
          this.passLoading = true;
          const param = {
            desc: this.passForm.reason,
            id: this.sureList,
          };
          this.$axios
            .put("/business/insertMonitor/insertIntoUrgeToReport", param)
            .then((res) => {
              this.$message.success("催报成功");
              this.getdata(1);
              this.passLoading = false;
              this.passDialogVisible = false;
            });
        }
      });
    },
    toPass(rowList) {
      if (rowList.length) {
        this.sureList = rowList;
        this.passForm = {
          reason: "",
        };
        this.passDialogVisible = true;
      }
    },
    handleSelectionChange(rowTable) {
      this.selectRow = [];
      rowTable.forEach((temp) => {
        this.selectRow.push(temp.id);
      });
    },
    handleCurrentChange(val) {
      //跳转页
      this.getdata(val);
    },
    onSubmit() {
      this.getdata(1);
    },
    reset() {
      this.formInline = {
        name: "",
        region: this.region,
        report_cycle: this.report_cycle,
        date_range: this.date_range,
        above_scale: "",
      };
      this.getdata(1);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getdata(1);
    },
    exportData() {
      let column = [
        {
          title: "填报单位",
          key: "company_name",
        },
        {
          title: "报表名",
          key: "name",
        },
        {
          title: "填报期",
          key: "date_range",
        },
        {
          title: "填报开始时间",
          key: "date_range",
        },
        {
          title: "填报结束时间",
          key: "date_range_end",
        },
        {
          title: "上报时间",
          key: "crt_time",
        },
      ];
      export2Excel(column, this.tableData, "未上报");
    },
  },
  created() {
    if (this.report_cycle) {
      this.formInline.report_cycle = this.report_cycle;
    }
    if (this.region) {
      this.formInline.region = this.region;
    }
    if (this.date_range) {
      this.formInline.date_range = this.date_range;
    }
    this.getdata();
  },
};
</script>

<style scoped>
.detail {
  width: 100%;
  height: 100%;
  cursor: pointer;
  color: #5584ff;
}
</style>